import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

/** Name der Kampagne in der Laufansicht des Wizards „Neue Kampagne“: die obere Leiste zeigt ihn als Breadcrumb. */
interface WizardCrumbStore {
  campaignName: string | null;
  setCampaignName: (name: string | null) => void;
}

const useWizardCrumbStore = createWithEqualityFn<WizardCrumbStore>(
  set => ({
    campaignName: null,
    setCampaignName(name) {
      set(() => ({ campaignName: name }));
    },
  }),
  shallow
);

export default useWizardCrumbStore;
